import { Reservation } from '@/plugins/api'
import { upsertMany } from '@/helpers'
import { sortBy } from 'lodash'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    reservations: [],
    isLoading: false
  },
  actions: {
    async fetchReservations({ commit }, options) {
      const res = await Reservation.fetch({ _sort: 'createdAt:desc', ...options })
      commit('setReservations', res)
    },
    async fetchReservation({ commit, state }, { id, options }) {
      const res = await Reservation.fetchOne(id, options)
      commit('setReservations', upsertMany(state.reservations, res))
    },
    async updateReservation({ commit, state }, { id, params, options }) {
      const res = await Reservation.update(id, params, options)
      commit(
        'setReservations',
        sortBy(upsertMany(state.reservations, res), i => moment(i, 'YYYY-MM-DD').unix())
      )
    },
    async createReservation({ commit, state }, { params, options }) {
      const res = await Reservation.create(params, options)
      commit(
        'setReservations',
        upsertMany(state.reservations, [
          ...state.reservations.map(i => ({ id: i.id, status: 'canceled' })),
          res
        ])
      )
    },
    async removeReservation({ commit, state }, { id, options }) {
      await Reservation.remove(id, options)
      commit(
        'setReservations',
        state.reservations.filter(i => i.id !== id)
      )
    },
    async swapReservation({ commit, state }, { id, params, options }) {
      await Reservation.swap(id, params, options)
      commit(
        'setReservations',
        state.reservations.filter(i => i.id !== id)
      )
    }
  },
  mutations: {
    setReservations(state, v) {
      state.reservations = v
    }
  }
}
